import Landpage from '../components/Landpage/Landpage'
import Why from '../components/why/Why'
import Plan from '../components/plans/Plan'
import Faq from '../components/Faq/Faq'
import Review from '../components/review/Review'
import Contact from '../components/contact/Contact'
import Footer from '../components/footer/Footer'
import TradersList from '../components/tradersList/TradersList'
import CardContainer from '../components/cardcontainer/CardContainer'
import TeslaWidgetContainer from '../components/Teslawidget/TeslaWidgetContainer'
import CryptoNewsContainer from '../components/CryptoNewsSection/CryptoNewsContainer'
import ForexAnalysisSection from '../components/ForexAnalysisSection/ForexAnalysisSection'
import Mt5Section from '../components/mt5/Mt5Section'
import Roadmap from '../components/roadmap/Roadmap'
// section heading styles (.videoframe-text-container, .header, .header-line, .highlight)
// shared by the public pages; this used to arrive via the removed Videoframe component
import '../styles/shared-sections.css'
const Home = () => {
  return (
    <main className='home-img'>
      <Landpage />
      <Roadmap />
      <CardContainer />
      <div className="mirror-divider" aria-hidden="true" />
      <Mt5Section />
      <TradersList />
      <Plan />
      <div className="mirror-divider" aria-hidden="true" />
      <TeslaWidgetContainer />
      <Why />
      <Review />
      <div className="mirror-divider" aria-hidden="true" />
      <CryptoNewsContainer />
      <ForexAnalysisSection />
      <Faq />
      <div className="mirror-divider" aria-hidden="true" />
      <Contact />
      <Footer />
    </main>
  )
}

export default Home